import { createSelector } from '@ngrx/store';

import { getBackAuthState } from '../auth.selectors';
import { IBackAuthState } from '../auth.state';
import { BackAuthEntitiesFeatureKey } from './entities.state';

export const getBackAuthEntitiesState = createSelector(
    getBackAuthState,
    (state: IBackAuthState) =>
        state[BackAuthEntitiesFeatureKey]
);
